@if (meeting$ | async; as result) {
  @if (result.isPending) {
    <app-spinner></app-spinner>
  } @else if (result.isError) {
    <h2 class="failed-to-load" translate="COMMON.FAILED_TO_LOAD"></h2>
  } @else {
    @if (result.data; as meeting) {
      <div class="page-container">
        <app-toolbar [title]="meeting.name" [backButtonLink]="getBackButtonLink(meeting)" [showSupportButton]="true">
          <app-meeting-details-bar class="details" [meeting]="meeting" [templateItems]="(templateItems$ | async) ?? []"></app-meeting-details-bar>
        </app-toolbar>
        <div class="page">
          <div class="wrapper">
            @if (currentUser$ | async; as user) {
              <app-meeting-setup [meeting]="meeting" [metadata]="meeting.agendaMetadata" [team]="user.team"></app-meeting-setup>
            }
          </div>
        </div>
      </div>
    }
  }
}
